export const HINT_WINDOW_PROPS = [
  'ontouchstart',
  'ongesturechange',
  'orientation',
  'chrome',
  'safari',
  'ApplePaySession',
  'InstallTrigger',
  'mozInnerScreenX',
  'mozInnerScreenY',
  'Dolphin',
  'dolphinGameCenter',
  'dolphininfo',
  'dolphinmeta',
  'MutationEvent',
  'showModalDialog',
  '__firefox__',
  'cssStyle',
  'noHightlightCSS',
  'com_huawei_browser_translate_obj',
];

export const HINT_NAVIGATOR_PROPS = [
  'oscpu',
  'buildID',
  'duckduckgo',
  '_duckduckgoloader_',
  'standalone',
  'brave',
  'connection',
];

export const HINT_DOCUMENT_PROPS = ['mozSetImageElement'];

function objectAt(value) {
  return value !== null && typeof value === 'object' ? value : null;
}

function within(source, build) {
  const obj = objectAt(source);
  if (!obj) return source === null ? null : undefined;
  return build(obj);
}

function pick(source, keys) {
  return within(source, function (obj) {
    const out = {};
    for (let i = 0; i < keys.length; i++) {
      if (obj[keys[i]] !== undefined) out[keys[i]] = obj[keys[i]];
    }
    return out;
  });
}

function presentProps(list, names) {
  if (!Array.isArray(list)) return undefined;
  const out = [];
  for (let i = 0; i < names.length; i++) {
    if (list.indexOf(names[i]) !== -1) out.push(names[i]);
  }
  return out;
}

function navigatorProperties(props) {
  const out = pick(props, ['userAgent', 'platform', 'maxTouchPoints', 'vendor', 'productSub', 'standalone']);
  out.userAgentData = pick(props.userAgentData, ['brands', 'mobile', 'platform']);
  return out;
}

function rendererVendor(webgl) {
  return within(webgl, function (gl) {
    return {
      details: within(gl.details, function (details) {
        return { unmaskedRendererInfo: pick(details.unmaskedRendererInfo, ['webglVendor']) };
      }),
    };
  });
}

function browserOther(other) {
  return {
    network: pick(other.network, ['type']),
    keyboard: pick(other.keyboard, ['status', 'size']),
    specific: within(other.specific, function (specific) {
      return {
        safari: pick(specific.safari, ['pushNotification']),
        brave: pick(specific.brave, ['isBrave']),
        tor: pick(specific.tor, ['isTor']),
        mullvad: pick(specific.mullvad, ['isMullvad']),
        errors: pick(specific.errors, ['negativeToFixed']),
      };
    }),
  };
}

export function deviceHint(data) {
  const source = objectAt(data);
  if (!source) return null;
  return {
    navigator: within(source.navigator, function (navigator) {
      return { properties: within(navigator.properties, navigatorProperties) };
    }),
    highEntropyValues: pick(source.highEntropyValues, ['platform', 'brands', 'fullVersionList', 'uaFullVersion']),
    javascript: within(source.javascript, function (javascript) {
      return {
        screen: pick(javascript.screen, ['width', 'height']),
        windowProps: presentProps(javascript.windowProps, HINT_WINDOW_PROPS),
        navigatorProps: presentProps(javascript.navigatorProps, HINT_NAVIGATOR_PROPS),
        documentProps: presentProps(javascript.documentProps, HINT_DOCUMENT_PROPS),
      };
    }),
    mediaQueries: pick(source.mediaQueries, ['pointerCoarse', 'anyHoverHover', 'hoverNone']),
    browser: within(source.browser, function (browser) {
      return { other: within(browser.other, browserOther) };
    }),
    fp: within(source.fp, function (fp) {
      return { webgl: rendererVendor(fp.webgl), webgl2: rendererVendor(fp.webgl2) };
    }),
    webWorker: within(source.webWorker, function (worker) {
      return {
        userAgent: worker.userAgent,
        highEntropyValues: pick(worker.highEntropyValues, ['brands', 'fullVersionList']),
      };
    }),
  };
}
